
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/unless-explanation';
const mainimage = '/Images/unless1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "unless" },
];

const Unless = () => (
  <GrammarPageLayout
    level="B2"
    title="Unless"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English “Unless” Exercises"
    seoDescription="Replace 'if not' with 'unless' for more natural conditionals. B2 level exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default Unless;

